import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

import { ModalCard, useCreateModal } from 'partial/components/Modal';
import AsyncButton from 'modules/common/components/AsyncButton';
import Password from '../components/Password';
import ConfirmPassword from './ConfirmPassword';

const ResetPass = ({ onClose, uuid }) => {
  const createModal = useCreateModal();
  const { values, setFieldValue } = useFormik({
    initialValues: {
      new_password: '',
      new_password_confirmation: '',
    },
  });

  const password = values?.new_password;
  const passwordConfirm = values?.new_password_confirmation;

  const testPassRegex = useMemo(() => {
    const pattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{10,}$/;
    return pattern?.test(password);
  }, [password]);

  const handleConfirm = useCallback(() => {
    createModal({
      content: (confirmClose) => (
        <ConfirmPassword
          onClose={confirmClose}
          uuid={uuid}
          otherFields={values}
        />
      ),
    });
    onClose();
  }, [createModal, uuid, values, onClose]);

  return (
    <ModalCard size="sm" title="RESET PASSWORD" onClose={onClose}>
      <div className="p-4 pt-2">
        <Password
          onChange={setFieldValue}
          password={password}
          passwordConfirm={passwordConfirm}
          testPassRegex={testPassRegex}
          passOnly={false}
        />

        <div className="flex justify-end gap-2 pt-8 border-neutral-200">
          <AsyncButton
            className="font-[400] !text-neutral-500"
            color="outline"
            onClick={onClose}
          >
            Cancel
          </AsyncButton>
          <AsyncButton
            className="font-[400]"
            color="outline"
            onClick={handleConfirm}
            disabled={password !== passwordConfirm || !testPassRegex}
          >
            confirm
          </AsyncButton>
        </div>
      </div>
    </ModalCard>
  );
};

ResetPass.propTypes = {
  onClose: PropTypes.func.isRequired,
  uuid: PropTypes.string.isRequired,
};

export default ResetPass;
